module.exports = __webpack_public_path__ + "img/Delete - Pink - Selected.bd31f963.png";